// extracted by mini-css-extract-plugin
export var centerText = "_bx-8";
export var container = "_bx-0";
export var doughnutContainer = "_bx-7";
export var legend = "_bx-a";
export var legendItemColorDisplay = "_bx-b";
export var legendItemLabel = "_bx-d";
export var legendItemValue = "_bx-c";
export var lg = "_bx-5";
export var maxWidth = "_bx-9";
export var md = "_bx-4";
export var responsive = "_bx-6";
export var sm = "_bx-3";
export var xs = "_bx-2";
export var xxs = "_bx-1";